"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../../Resource"));
const class_transformer_1 = require("class-transformer");
const EAutreCgpGroups_1 = require("../../../enums/Scpi/PhysicalPerson/Groups/EAutreCgpGroups");
const ESubModeEntreeRelation_1 = require("../../../enums/Scpi/PhysicalPerson/AutreCgp/ESubModeEntreeRelation");
const ESubCommentConnuConsultim_1 = require("../../../enums/Scpi/PhysicalPerson/AutreCgp/ESubCommentConnuConsultim");
class GenericAutreCgpRequestResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.category = "autre_cgp";
    }
}
exports.default = GenericAutreCgpRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationClient] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationClient] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationClient] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "appreciationClient", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationOperation] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationOperation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.appreciationOperation] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "appreciationOperation", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubModeEntreeRelation_1.ESubModeEntreeRelation, { groups: [EAutreCgpGroups_1.EAutreCgpGroups.modeEntreeRelation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.modeEntreeRelation] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "modeEntreeRelation", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(ESubCommentConnuConsultim_1.ESubCommentConnuConsultim, { groups: [EAutreCgpGroups_1.EAutreCgpGroups.commentConnuConsultim] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.commentConnuConsultim] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "commentConnuConsultim", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.dateEntreeRelation] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.dateEntreeRelation] }),
    __metadata("design:type", Date)
], GenericAutreCgpRequestResource.prototype, "dateEntreeRelation", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    __metadata("design:type", Boolean)
], GenericAutreCgpRequestResource.prototype, "coherenceSituationPatrimonialeEtInvestissement", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.coherenceSituationPatrimonialeEtInvestissement === false, { groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    (0, class_validator_1.IsNotEmpty)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    (0, class_validator_1.IsString)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    (0, class_transformer_1.Expose)({ groups: [EAutreCgpGroups_1.EAutreCgpGroups.coherenceSituationPatrimonialeEtInvestissement] }),
    __metadata("design:type", String)
], GenericAutreCgpRequestResource.prototype, "coherenceSituationPatrimonialeEtInvestissementPrecision", void 0);
